module.exports = __webpack_public_path__ + "img/biaoti.37f7e458.jpg";